export default __webpack_public_path__ + "static/media/texture-map.583f6075.jpg";